const ukuleleChords = JSON.parse(`{
  "main":{
     "strings":4,
     "fretsOnChord":4,
     "name":"ukulele",
     "numberOfChords":2114
  },
  "tunings":{
     "standard":[
        "G4",
        "C4",
        "E4",
        "A4"
     ]
  },
  "keys":[
     "C",
     "Db",
     "D",
     "Eb",
     "E",
     "F",
     "Gb",
     "G",
     "Ab",
     "A",
     "Bb",
     "B"
  ],
  "suffixes":[
     "major",
     "minor",
     "dim",
     "dim7",
     "sus2",
     "sus4",
     "7sus4",
     "alt",
     "aug",
     "6",
     "69",
     "7",
     "7b5",
     "aug7",
     "9",
     "9b5",
     "aug9",
     "7b9",
     "7b9#5",
     "7#9",
     "11",
     "9#11",
     "13",
     "13b9",
     "13b5b9",
     "b13b9",
     "b13#9",
     "maj7",
     "maj7b5",
     "maj7#5",
     "maj9",
     "maj11",
     "maj13",
     "m6",
     "m7",
     "m7b5",
     "m9",
     "m69",
     "m9b5",
     "m11",
     "mmaj7",
     "mmaj7b5",
     "mmaj9",
     "mmaj11",
     "add9",
     "madd9"
  ],
  "chords":{
     "A":[
        {
           "key":"A",
           "suffix":"major",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    0,
                    0
                 ],
                 "fingers":[
                    2,
                    1,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    61,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    73,
                    64,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    69,
                    73,
                    81
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"minor",
           "positions":[
              {
                 "frets":[
                    2,
                    0,
                    0,
                    0
                 ],
                 "fingers":[
                    2,
                    0,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    60,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    0,
                    0,
                    3
                 ],
                 "fingers":[
                    2,
                    0,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    60,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    69,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    69,
                    72
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"dim",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    69,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    72,
                    63,
                    69,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    72,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    81,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"dim7",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"sus2",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    64,
                    69,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    64,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    76,
                    69,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "barres":[
                    4
                 ],
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"sus4",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    0,
                    0
                 ],
                 "fingers":[
                    2,
                    3,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    74,
                    64,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    64,
                    69,
                    76
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"7sus4",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    0,
                    0
                 ],
                 "fingers":[
                    0,
                    2,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    69,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"alt",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    63,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    69,
                    73,
                    75
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"aug",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    1,
                    0
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    61,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    61,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    65,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    73,
                    65,
                    69,
                    77
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"6",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    69,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    73,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"69",
           "positions":[
              {
                 "frets":[
                    4,
                    4,
                    2,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    73,
                    76,
                    83
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"7",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    0
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    69,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"aug7",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    0
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    77,
                    69,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"9b5",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    3,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    71,
                    73,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    73,
                    75,
                    83
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"aug9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":1,
                 "midi":[
                    67,
                    61,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"7b9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"7b9#5",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"7#9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    3
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    73,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    72,
                    76
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"11",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    3,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    62,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    4,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    71,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    74
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"9#11",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    3,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    71,
                    73,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    73,
                    75,
                    83
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"13",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    71,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"13b9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    3,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    66,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    70,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    79,
                    70,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"13b5b9",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    66,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    67,
                    70,
                    78
                 ]
              },
              {
                 "frets":[
                    0,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    0,
                    2,
                    3,
                    1
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    70,
                    75,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    70,
                    75,
                    79
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"b13b9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"b13#9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    73,
                    65,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"maj7",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    0,
                    0
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    69,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"maj7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    80
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    81,
                    73,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"maj7#5",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    1,
                    0
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    65,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    77,
                    69,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"maj9",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    0,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    4
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"maj11",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    4,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    62,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    71,
                    74
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"maj13",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    71,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"m6",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"m7",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    0,
                    0
                 ],
                 "fingers":[
                    0,
                    0,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    69,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    76,
                    69,
                    72,
                    79
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"m7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"m9",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    0,
                    2
                 ],
                 "fingers":[
                    0,
                    0,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    3,
                    4
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"m69",
           "positions":[
              {
                 "frets":[
                    4,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    72,
                    64,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    72,
                    78
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"m9b5",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":2,
                 "midi":[
                    72,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    71,
                    72,
                    79
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"m11",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    71,
                    62,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    72,
                    62,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    71,
                    74
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"mmaj7",
           "positions":[
              {
                 "frets":[
                    1,
                    0,
                    0,
                    0
                 ],
                 "fingers":[
                    1,
                    0,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    60,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    68,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    76,
                    69,
                    72,
                    80
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"mmaj7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    68,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    72,
                    80
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"mmaj9",
           "positions":[
              {
                 "frets":[
                    1,
                    0,
                    0,
                    2
                 ],
                 "fingers":[
                    1,
                    0,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    60,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    68,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"mmaj11",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    4,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    62,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    72,
                    62,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    68,
                    71,
                    74
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"add9",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    0,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    61,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    64,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    73,
                    69,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    73,
                    81
                 ]
              }
           ]
        },
        {
           "key":"A",
           "suffix":"madd9",
           "positions":[
              {
                 "frets":[
                    2,
                    0,
                    0,
                    2
                 ],
                 "fingers":[
                    2,
                    0,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    60,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    69,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    71,
                    64,
                    69,
                    72
                 ]
              }
           ]
        }
     ],
     "Ab":[
        {
           "key":"Ab",
           "suffix":"major",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    72,
                    63,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    63,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    68,
                    72,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"minor",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    4,
                    2
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    2,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    71,
                    75
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"dim",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    4,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    62,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    71,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"dim7",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"sus2",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    68,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    63,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    75,
                    68,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "barres":[
                    4
                 ],
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"sus4",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    73,
                    63,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    63,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    73,
                    75
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"7sus4",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    68,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"alt",
           "positions":[
              {
                 "frets":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    62,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    68,
                    72,
                    74
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"aug",
           "positions":[
              {
                 "frets":[
                    1,
                    0,
                    0,
                    3
                 ],
                 "fingers":[
                    1,
                    0,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    60,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    72,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    72,
                    64,
                    68,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"6",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    68,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    72,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"69",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    65,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    72,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"7",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    68,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    72,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"aug7",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    76,
                    68,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    72,
                    76,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"9",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    72,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"9b5",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    62,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    74,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"aug9",
           "positions":[
              {
                 "frets":[
                    3,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    76,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"7b9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"7b9#5",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"7#9",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    72,
                    63,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    71,
                    72,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    61,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    4,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    70,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    73
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"9#11",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    62,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    74,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"13",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    78,
                    70,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"13b9",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    65,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    78,
                    69,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    77,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"13b5b9",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    65,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    66,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    69,
                    74,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    69,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"b13b9",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"b13#9",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    72,
                    64,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    72,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"maj7",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    68,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    72,
                    75,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"maj7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    80,
                    72,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"maj7#5",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    76,
                    68,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    72,
                    76,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"maj9",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":11,
                 "midi":[
                    79,
                    72,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"maj11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    61,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    70,
                    73
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"maj13",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    1,
                    1
                 ],
                 "fingers":[
                    0,
                    0,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    72,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"m6",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"m7",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    75,
                    68,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    71,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"m7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"m9",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    2,
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    71,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"m69",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    71,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"m9b5",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    71,
                    62,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    70,
                    71,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"m11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    70,
                    61,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    61,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    70,
                    73
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"mmaj7",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    67,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    75,
                    68,
                    71,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":10,
                 "midi":[
                    80,
                    71,
                    75,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"mmaj7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    67,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    71,
                    79
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"mmaj9",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    67,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    71,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"mmaj11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    61,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    61,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    67,
                    70,
                    73
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"add9",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    72,
                    68,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    72,
                    80
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    72,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Ab",
           "suffix":"madd9",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    68,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    4,
                    2
                 ],
                 "fingers":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    80,
                    71,
                    75,
                    82
                 ]
              }
           ]
        }
     ],
     "B":[
        {
           "key":"B",
           "suffix":"major",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    75,
                    66,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    71,
                    75,
                    83
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"minor",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    71,
                    62,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    71,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    66,
                    71,
                    74
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"dim",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    71,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    74,
                    65,
                    71,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    74,
                    77
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"dim7",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"sus2",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    71,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    78,
                    71,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "barres":[
                    4
                 ],
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    78,
                    83
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"sus4",
           "positions":[
              {
                 "frets":[
                    4,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    64,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    76,
                    66,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    66,
                    71,
                    78
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"7sus4",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    64,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "baseFret":11,
                 "midi":[
                    78,
                    71,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"alt",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    65,
                    71,
                    75
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"aug",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    0,
                    2,
                    3,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    71,
                    63,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    67,
                    71,
                    75
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"6",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    71,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"69",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    68,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"7",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    63,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    71,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"aug7",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2,
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    71,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    79,
                    71,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    63,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"9b5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    73,
                    65,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    73,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"aug9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    69,
                    63,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    73,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"7b9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"7b9#5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"7#9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    63,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    75,
                    66,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"11",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    0,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    64,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    64,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    4,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    73,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    76
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"9#11",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":5,
                 "midi":[
                    73,
                    65,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    73,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"13",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    80
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"13b9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    68,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    72,
                    80
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    81,
                    72,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"13b5b9",
           "positions":[
              {
                 "frets":[
                    1,
                    0,
                    1,
                    0
                 ],
                 "fingers":[
                    1,
                    0,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    60,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    65,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    68,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    69,
                    72,
                    80
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"b13b9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"b13#9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    75,
                    67,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"maj7",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    71,
                    78
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"maj7b5",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    71,
                    77
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"maj7#5",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    67,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    71,
                    79
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"maj9",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    73,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"maj11",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    0,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    64,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    64,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    73,
                    76
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"maj13",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    3,
                    4
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    73,
                    80
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    73,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"m6",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"m7",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":10,
                 "midi":[
                    78,
                    71,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"m7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    71,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"m9",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    66,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    73,
                    66,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"m69",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    74,
                    66,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"m9b5",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    74,
                    65,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    73,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    73,
                    77
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"m11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    73,
                    64,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    74,
                    64,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    73,
                    76
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"mmaj7",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    71,
                    62,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    70,
                    71,
                    78
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"mmaj7b5",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    62,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    70,
                    71,
                    77
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"mmaj9",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    62,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    66,
                    70,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    70,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"mmaj11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    64,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    74,
                    64,
                    70,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    70,
                    73,
                    76
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"add9",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    75,
                    71,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    75,
                    83
                 ]
              }
           ]
        },
        {
           "key":"B",
           "suffix":"madd9",
           "positions":[
              {
                 "frets":[
                    2,
                    0,
                    0,
                    2
                 ],
                 "fingers":[
                    2,
                    0,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    60,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    69,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    71,
                    64,
                    69,
                    72
                 ]
              }
           ]
        }
     ],
     "Bb":[
        {
           "key":"Bb",
           "suffix":"major",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    62,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    74,
                    65,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    70,
                    74,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"minor",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    61,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    61,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    70,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    70,
                    73
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"dim",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    70,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    73,
                    64,
                    70,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    73,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"dim7",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"sus2",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    70,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":5,
                 "midi":[
                    72,
                    65,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":8,
                 "midi":[
                    77,
                    70,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "barres":[
                    4
                 ],
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    77,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"sus4",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    75,
                    65,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    65,
                    70,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"7sus4",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    70,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"alt",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    64,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    70,
                    74,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"aug",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    70,
                    62,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    70,
                    62,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    66,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    74,
                    66,
                    70,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"6",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    0,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":1,
                 "midi":[
                    67,
                    62,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    70,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"69",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    0,
                    2,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    67,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"7",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    70,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"aug7",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    70,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    78,
                    70,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"9b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":4,
                 "midi":[
                    72,
                    64,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    72,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"aug9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"7b9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"7b9#5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"7#9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    74,
                    65,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    73,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    63,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    4,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    72,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    75
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"9#11",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    72,
                    64,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    72,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"13",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"13b9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    67,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    71,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    80,
                    71,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"13b5b9",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    64,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    67,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    68,
                    71,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    71,
                    76,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"b13b9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"b13#9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    74,
                    66,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"maj7",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    1,
                    0
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    70,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"maj7b5",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    0,
                    0
                 ],
                 "fingers":[
                    3,
                    2,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    70,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"maj7#5",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    2,
                    0
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    66,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    66,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    70,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"maj9",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    72,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"maj11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    63,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    72,
                    75
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"maj13",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2,
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    72,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"m6",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"m7",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":9,
                 "midi":[
                    77,
                    70,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"m7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    70,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"m9",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    72,
                    65,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"m69",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    0,
                    2,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    73,
                    65,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"m9b5",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    0,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    72,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    73,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    72,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"m11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    72,
                    63,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    73,
                    63,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    72,
                    75
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"mmaj7",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    1,
                    0
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    61,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    61,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    69,
                    70,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"mmaj7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    0,
                    0
                 ],
                 "fingers":[
                    3,
                    1,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    61,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    69,
                    70,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"mmaj9",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    61,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    69,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    69,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"mmaj11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    63,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    73,
                    63,
                    69,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    69,
                    72,
                    75
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"add9",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    65,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    74,
                    70,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    74,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Bb",
           "suffix":"madd9",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    61,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    70,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    72,
                    65,
                    70,
                    73
                 ]
              }
           ]
        }
     ],
     "C":[
        {
           "key":"C",
           "suffix":"major",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    0,
                    3
                 ],
                 "fingers":[
                    0,
                    0,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    0,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    0,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    67,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    72,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    72,
                    76
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"minor",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    72,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    72,
                    63,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    72,
                    75
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"dim",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    72,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    75,
                    66,
                    72,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    75,
                    78
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"dim7",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"sus2",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    67,
                    62,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    72,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    67,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    79,
                    72,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"sus4",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    1,
                    3
                 ],
                 "fingers":[
                    0,
                    0,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    72,
                    65,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    67,
                    72,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"7sus4",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    1,
                    1
                 ],
                 "fingers":[
                    0,
                    0,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    72,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"alt",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    72,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    66,
                    72,
                    76
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"aug",
           "positions":[
              {
                 "frets":[
                    1,
                    0,
                    0,
                    3
                 ],
                 "fingers":[
                    1,
                    0,
                    0,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    60,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    72,
                    64,
                    68,
                    76
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"6",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    0,
                    0
                 ],
                 "fingers":[
                    0,
                    0,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    76,
                    69,
                    72,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"69",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    0,
                    0
                 ],
                 "fingers":[
                    0,
                    2,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    69,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"7",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    0,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    72,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"7b5",
           "positions":[
              {
                 "frets":[
                    3,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    76,
                    82
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"aug7",
           "positions":[
              {
                 "frets":[
                    1,
                    0,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    0,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    60,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    72,
                    80
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"9",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    2,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    64,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"9b5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    74,
                    66,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    70,
                    74,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    74,
                    76,
                    82
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"aug9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"7b9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"7b9#5",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    70,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"7#9",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    3,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    64,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    76,
                    67,
                    70,
                    75
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    65,
                    70,
                    76
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"9#11",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    74,
                    66,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    70,
                    74,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    74,
                    76,
                    82
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"13",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    0,
                    0
                 ],
                 "fingers":[
                    3,
                    2,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    70,
                    76
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"13b9",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    0,
                    0
                 ],
                 "fingers":[
                    3,
                    1,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    61,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    69,
                    70,
                    76
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"13b5b9",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    61,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    0
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    61,
                    66,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    66,
                    69,
                    73
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"b13b9",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    70,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"b13#9",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    76,
                    68,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    70,
                    76
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"maj7",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    0,
                    2
                 ],
                 "fingers":[
                    0,
                    0,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"maj7b5",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    72,
                    64,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    72,
                    78
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"maj7#5",
           "positions":[
              {
                 "frets":[
                    1,
                    0,
                    0,
                    2
                 ],
                 "fingers":[
                    1,
                    0,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    60,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    68,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"maj9",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    0,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    71,
                    64,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    67,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"maj11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    65,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    74,
                    77
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"maj13",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    0,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    64,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"m6",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"m7",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":11,
                 "midi":[
                    79,
                    72,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"m7b5",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    72,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"m9",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":3,
                 "midi":[
                    70,
                    63,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    67,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    74,
                    67,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"m69",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    75,
                    67,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"m9b5",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":2,
                 "midi":[
                    70,
                    63,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    75,
                    66,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    74,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"m11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    74,
                    65,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    75,
                    65,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    74,
                    77
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"mmaj7",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":2,
                 "midi":[
                    72,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    71,
                    72,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"mmaj7b5",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    72,
                    63,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    71,
                    75
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"mmaj9",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    71,
                    63,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    67,
                    71,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    71,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"mmaj11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    65,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    75,
                    65,
                    71,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    71,
                    74,
                    77
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"add9",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    0,
                    3
                 ],
                 "fingers":[
                    0,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    67,
                    72,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":9,
                 "midi":[
                    76,
                    72,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"C",
           "suffix":"madd9",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    72,
                    63,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    67,
                    72,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    74,
                    67,
                    72,
                    75
                 ]
              }
           ]
        }
     ],
     "D":[
        {
           "key":"D",
           "suffix":"major",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    2,
                    0
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    66,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    62,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    74,
                    66,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"minor",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    0
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    74,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    74,
                    65,
                    69,
                    77
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"dim",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    74,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    77,
                    68,
                    74,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    74,
                    77,
                    80
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"dim7",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"sus2",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "barres":[
                    4
                 ],
                 "baseFret":2,
                 "midi":[
                    69,
                    64,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    74,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    69,
                    74,
                    81
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":12,
                 "midi":[
                    81,
                    74,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"sus4",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    3,
                    0
                 ],
                 "fingers":[
                    0,
                    2,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    67,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    3,
                    0
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    67,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    62,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    74,
                    67,
                    69,
                    74
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"7sus4",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2,
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    72,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"alt",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    74,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    68,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"aug",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    70,
                    62,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    70,
                    62,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    66,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    74,
                    66,
                    70,
                    78
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"6",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":10,
                 "midi":[
                    78,
                    71,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"69",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    64,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    71,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"7",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"aug7",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    62,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    74,
                    82
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"9",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"9b5",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    76,
                    68,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    72,
                    76,
                    80
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"aug9",
           "positions":[
              {
                 "frets":[
                    3,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    72,
                    78
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"7b9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"7b9#5",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    72,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"7#9",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    65,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    78,
                    69,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"11",
           "positions":[
              {
                 "frets":[
                    0,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    0,
                    3,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    67,
                    72,
                    78
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"9#11",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    76,
                    68,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    72,
                    76,
                    80
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"13",
           "positions":[
              {
                 "frets":[
                    4,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    72,
                    64,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    72,
                    78
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"13b9",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    72,
                    63,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    71,
                    72,
                    78
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"13b5b9",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    63,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    4,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    68,
                    71,
                    75
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"b13b9",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    72,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"b13#9",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    78,
                    70,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    72,
                    78
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"maj7",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    66,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    73,
                    66,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"maj7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    74,
                    66,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"maj7#5",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    62,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    66,
                    70,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    70,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"maj9",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    73,
                    66,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    69,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"maj11",
           "positions":[
              {
                 "frets":[
                    0,
                    4,
                    2,
                    4
                 ],
                 "fingers":[
                    0,
                    2,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    64,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    67,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    73,
                    76,
                    79
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"maj13",
           "positions":[
              {
                 "frets":[
                    4,
                    4,
                    2,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    73,
                    76,
                    83
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"m6",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    71,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"m7",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    72,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"m7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"m9",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    65,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    69,
                    72,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    76,
                    69,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"m69",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    77,
                    69,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"m9b5",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    64,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    72,
                    65,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    77,
                    68,
                    72,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    76,
                    68,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"m11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    76,
                    67,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    77,
                    67,
                    72,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    76,
                    79
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"mmaj7",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    74,
                    65,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    73,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    73,
                    77
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"mmaj7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    74,
                    65,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    73,
                    77
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"mmaj9",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    73,
                    65,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    69,
                    73,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    73,
                    77
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"mmaj11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    67,
                    73,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    77,
                    67,
                    73,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    73,
                    76,
                    79
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"add9",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    64,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    66,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    69,
                    74,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":11,
                 "midi":[
                    78,
                    74,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"D",
           "suffix":"madd9",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    74,
                    65,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    69,
                    74,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    76,
                    69,
                    74,
                    77
                 ]
              }
           ]
        }
     ],
     "Db":[
        {
           "key":"Db",
           "suffix":"major",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    73,
                    65,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    73,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    77,
                    68,
                    73,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"minor",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    73,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    73,
                    64,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    73,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"dim",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    73,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    76,
                    67,
                    73,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    73,
                    76,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"dim7",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"sus2",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "barres":[
                    4
                 ],
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    73,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    68,
                    73,
                    80
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    80,
                    73,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"sus4",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    73,
                    66,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    68,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"7sus4",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    71,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"alt",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    0,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":1,
                 "midi":[
                    67,
                    61,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    73,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    67,
                    73,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"aug",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    1,
                    0
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    61,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    61,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    65,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    69,
                    73
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"6",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":9,
                 "midi":[
                    77,
                    70,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"69",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    70,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"7",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"7b5",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"aug7",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    61,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    73,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"9",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"9b5",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    0,
                    3,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    75,
                    67,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    71,
                    75,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"aug9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    0
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    71,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"7b9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"7b9#5",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    71,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"7#9",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    64,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    77,
                    68,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    66,
                    71,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"9#11",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    0,
                    3,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    75,
                    67,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    71,
                    75,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"13",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    71,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"13b9",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    62,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    70,
                    71,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"13b5b9",
           "positions":[
              {
                 "frets":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    62,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    67,
                    70,
                    74
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"b13b9",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    71,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"b13#9",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    77,
                    69,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    71,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"maj7",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    72,
                    65,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"maj7b5",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    73,
                    65,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"maj7#5",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    61,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    69,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    69,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"maj9",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    72,
                    65,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    68,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"maj11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    66,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    72,
                    75,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"maj13",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    65,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    72,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"m6",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    70,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"m7",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    0,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    4
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"m7b5",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"m9",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    0,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    64,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    68,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    75,
                    68,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"m69",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    76,
                    68,
                    70,
                    75
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"m9b5",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    0,
                    2
                 ],
                 "fingers":[
                    0,
                    2,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    71,
                    64,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    76,
                    67,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    75,
                    67,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"m11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    75,
                    66,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    76,
                    66,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    75,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"mmaj7",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    0,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    72,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    73,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    72,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"mmaj7b5",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    3
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    73,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    72,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"mmaj9",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    0,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    72,
                    64,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    68,
                    72,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    72,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"mmaj11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    66,
                    72,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    76,
                    66,
                    72,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    72,
                    75,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"add9",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":8,
                 "midi":[
                    75,
                    68,
                    73,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":10,
                 "midi":[
                    77,
                    73,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Db",
           "suffix":"madd9",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    73,
                    64,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    68,
                    73,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    75,
                    68,
                    73,
                    76
                 ]
              }
           ]
        }
     ],
     "E":[
        {
           "key":"E",
           "suffix":"major",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    0,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    64,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    4,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    64,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    76,
                    68,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"minor",
           "positions":[
              {
                 "frets":[
                    0,
                    4,
                    3,
                    2
                 ],
                 "fingers":[
                    0,
                    3,
                    2,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    64,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    2,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    67,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    76,
                    67,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"dim",
           "positions":[
              {
                 "frets":[
                    3,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    76,
                    79
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    79,
                    70,
                    76,
                    79
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"dim7",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"sus2",
           "positions":[
              {
                 "frets":[
                    4,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    64,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "barres":[
                    4
                 ],
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    76,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    71,
                    76,
                    83
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"sus4",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    64,
                    69,
                    71
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    69,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    64,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    76,
                    69,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"7sus4",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    0,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    64,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"alt",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    76,
                    80
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    70,
                    76,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"aug",
           "positions":[
              {
                 "frets":[
                    1,
                    0,
                    0,
                    3
                 ],
                 "fingers":[
                    1,
                    0,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    60,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    72,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    72,
                    64,
                    68,
                    76
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"6",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    0,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    4
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"69",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    71,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"7",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    0,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    64,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"aug7",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":4,
                 "midi":[
                    72,
                    64,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    72,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"9b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    70,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    78,
                    70,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"aug9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"7b9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"7b9#5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"7#9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    67,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    68,
                    71,
                    79
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"11",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    0
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    69
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"9#11",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    70,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    78,
                    70,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"13",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    74,
                    66,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"13b9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    74,
                    65,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    73,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"13b5b9",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    65,
                    70,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    70,
                    73,
                    77
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"b13b9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"b13#9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    80,
                    72,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"maj7",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    0,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    64,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    68,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    75,
                    68,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"maj7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    76,
                    68,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    70,
                    76
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"maj7#5",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    0,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    72,
                    64,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    68,
                    72,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    72,
                    76
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"maj9",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    75,
                    68,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    71,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"maj11",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    2,
                    0
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    66,
                    69
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    69,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"maj13",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    68,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"m6",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"m7",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    0,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    71,
                    64,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    67,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"m7b5",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    2,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    64,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"m9",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    67,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    71,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"m69",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    71,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"m9b5",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    0,
                    2,
                    3,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    66,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    74,
                    67,
                    70,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":9,
                 "midi":[
                    79,
                    70,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"m11",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    2,
                    0
                 ],
                 "fingers":[
                    0,
                    2,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    66,
                    69
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":9,
                 "midi":[
                    78,
                    69,
                    74,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    79,
                    69,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"mmaj7",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    0,
                    2
                 ],
                 "fingers":[
                    0,
                    2,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    71,
                    64,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    76,
                    67,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    75,
                    67,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"mmaj7b5",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    3,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    64,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    76,
                    67,
                    70,
                    75
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"mmaj9",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    0,
                    3,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    75,
                    67,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    71,
                    75,
                    78
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"mmaj11",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    2,
                    0
                 ],
                 "fingers":[
                    0,
                    3,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    66,
                    69
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    69,
                    75,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    79,
                    69,
                    75,
                    78
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"add9",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    68,
                    64,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    68,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    71,
                    76,
                    80
                 ]
              }
           ]
        },
        {
           "key":"E",
           "suffix":"madd9",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    76,
                    67,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    71,
                    76,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":10,
                 "midi":[
                    78,
                    71,
                    76,
                    79
                 ]
              }
           ]
        }
     ],
     "Eb":[
        {
           "key":"Eb",
           "suffix":"major",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    0,
                    3,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    63,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    75,
                    67,
                    70,
                    75
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"minor",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    2,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "barres":[
                    4
                 ],
                 "baseFret":3,
                 "midi":[
                    70,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    75,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    75,
                    66,
                    70,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"dim",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    0
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    66,
                    69
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    75,
                    78
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    78,
                    69,
                    75,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"dim7",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"sus2",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "barres":[
                    4
                 ],
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    75,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    70,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"sus4",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    68,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    68,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    63,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    75,
                    68,
                    70,
                    75
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"7sus4",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    3,
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    73,
                    80
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    73,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"alt",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    75,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    69,
                    75,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"aug",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    0,
                    3,
                    2,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    71,
                    63,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    67,
                    71,
                    75
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"6",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":11,
                 "midi":[
                    79,
                    72,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"69",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    1,
                    1
                 ],
                 "fingers":[
                    0,
                    0,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    72,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"7",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    73,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    73,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"aug7",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    3,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    71,
                    73,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    73,
                    75,
                    83
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"9b5",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    0
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    77,
                    69,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"aug9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":1,
                 "midi":[
                    67,
                    61,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"7b9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"7b9#5",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"7#9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    3,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    66,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    70,
                    78
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    68,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"9#11",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    0
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    77,
                    69,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"13",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    73,
                    65,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"13b9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    3
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    73,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    72,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"13b5b9",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    0,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    61,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    64,
                    69,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    69,
                    72,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"b13b9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"b13#9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    79,
                    71,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"maj7",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    63,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    67,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    74,
                    67,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"maj7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    75,
                    67,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"maj7#5",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    71,
                    63,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    67,
                    71,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    71,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"maj9",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    0,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":1,
                 "midi":[
                    67,
                    62,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    74,
                    67,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    70,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"maj11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    68,
                    74,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    74,
                    77,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"maj13",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    0,
                    2,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    67,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"m6",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    72,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"m7",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    73,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"m7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    63,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"m9",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    70,
                    73,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    77,
                    70,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"m69",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    78,
                    70,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"m9b5",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    65,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    73,
                    66,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    78,
                    69,
                    73,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    77,
                    69,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"m11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    77,
                    68,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    78,
                    68,
                    73,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    77,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"mmaj7",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":2,
                 "midi":[
                    70,
                    63,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    75,
                    66,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    74,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"mmaj7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    63,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    75,
                    66,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"mmaj9",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    74,
                    66,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    70,
                    74,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"mmaj11",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    68,
                    74,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    78,
                    68,
                    74,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    74,
                    77,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"add9",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    0,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":1,
                 "midi":[
                    67,
                    63,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    67,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    70,
                    75,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Eb",
           "suffix":"madd9",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    75,
                    66,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    70,
                    75,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":9,
                 "midi":[
                    77,
                    70,
                    75,
                    78
                 ]
              }
           ]
        }
     ],
     "F":[
        {
           "key":"F",
           "suffix":"major",
           "positions":[
              {
                 "frets":[
                    2,
                    0,
                    1,
                    0
                 ],
                 "fingers":[
                    2,
                    0,
                    1,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    60,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    0,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    0,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    60,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    65,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    77,
                    69,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"minor",
           "positions":[
              {
                 "frets":[
                    1,
                    0,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    0,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    60,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    2,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    68,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    77,
                    68,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"dim",
           "positions":[
              {
                 "frets":[
                    3,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    77,
                    80
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    80,
                    71,
                    77,
                    80
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"dim7",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"sus2",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    1,
                    3
                 ],
                 "fingers":[
                    0,
                    0,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    72,
                    65,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "barres":[
                    4
                 ],
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    77,
                    79
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"sus4",
           "positions":[
              {
                 "frets":[
                    3,
                    0,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    0,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":1,
                 "midi":[
                    70,
                    60,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    0,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    0,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    60,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    70,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    70,
                    72
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"7sus4",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    65,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    70,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    72,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"alt",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    65,
                    69,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    77,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"aug",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    1,
                    0
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    61,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    61,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    65,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    73,
                    65,
                    69,
                    77
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"6",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    72,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"69",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2,
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    72,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"7",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    65,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"aug7",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    73,
                    65,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    73,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"9b5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2,
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    71,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    79,
                    71,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"aug9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    69,
                    63,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"7b9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"7b9#5",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    63,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"7#9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    68,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    69,
                    72,
                    80
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"11",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    0
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    66,
                    69
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"9#11",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2,
                    3
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    71,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    79,
                    71,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"13",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    75,
                    67,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"13b9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    63,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    75,
                    66,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    74,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    74,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"13b5b9",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    63,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    66,
                    71,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    66,
                    71,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    2
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    71,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"b13b9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    63,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"b13#9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    80
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    81,
                    73,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"maj7",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    65,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    69,
                    72,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    76,
                    69,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"maj7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    77,
                    69,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    71,
                    77
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"maj7#5",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    73,
                    65,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    69,
                    73,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    73,
                    77
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"maj9",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    0,
                    0
                 ],
                 "fingers":[
                    0,
                    0,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    69,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    76,
                    69,
                    72,
                    79
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"maj11",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    70,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"maj13",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    0,
                    0
                 ],
                 "fingers":[
                    0,
                    2,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    69,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"m6",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    62,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"m7",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    72,
                    65,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    68,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"m7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"m9",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    75,
                    68,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    72,
                    75,
                    79
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"m69",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    72,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"m9b5",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    67,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    75,
                    68,
                    71,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":10,
                 "midi":[
                    80,
                    71,
                    75,
                    79
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"m11",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":10,
                 "midi":[
                    79,
                    70,
                    75,
                    80
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    80,
                    70,
                    75,
                    79
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"mmaj7",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    64,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    72,
                    65,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":7,
                 "midi":[
                    77,
                    68,
                    72,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    76,
                    68,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"mmaj7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    64,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    77,
                    68,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"mmaj9",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    64,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    67,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    76,
                    68,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    72,
                    76,
                    79
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"mmaj11",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    64,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    70,
                    76,
                    80
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    80,
                    70,
                    76,
                    79
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"add9",
           "positions":[
              {
                 "frets":[
                    0,
                    0,
                    1,
                    0
                 ],
                 "fingers":[
                    0,
                    0,
                    1,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    60,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":2,
                 "midi":[
                    69,
                    65,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    69,
                    72,
                    79
                 ]
              }
           ]
        },
        {
           "key":"F",
           "suffix":"madd9",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    0,
                    3,
                    2,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    65,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    77,
                    68,
                    72,
                    79
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    72,
                    77,
                    79
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":11,
                 "midi":[
                    79,
                    72,
                    77,
                    80
                 ]
              }
           ]
        }
     ],
     "G":[
        {
           "key":"G",
           "suffix":"major",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    3,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    62,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    62,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    67,
                    71,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"minor",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    0,
                    2,
                    3,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    2,
                    1
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    70,
                    74
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"dim",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    3,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    61,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    70,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"dim7",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"sus2",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    3,
                    0
                 ],
                 "fingers":[
                    0,
                    2,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    67,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    62,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    74,
                    67,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "barres":[
                    4
                 ],
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"sus4",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":2,
                 "midi":[
                    72,
                    62,
                    67,
                    72
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    62,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    67,
                    72,
                    74
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"7sus4",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    0,
                    2,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    65,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    67,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    72,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"alt",
           "positions":[
              {
                 "frets":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    61,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    67,
                    71,
                    73
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    71,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"aug",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    0,
                    2,
                    3,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    3
                 ],
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    71,
                    63,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    67,
                    71,
                    75
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"6",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    0,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    67,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"69",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    0,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    64,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    64,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    71,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"7",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    0,
                    2,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    67,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    71,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"7b5",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"aug7",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    0,
                    3,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    75,
                    67,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    71,
                    75,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"9",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    71,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"9b5",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":1,
                 "midi":[
                    69,
                    61,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    73,
                    81
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"aug9",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"7b9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"7b9#5",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"7#9",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    62,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    70,
                    71,
                    77
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"11",
           "positions":[
              {
                 "frets":[
                    2,
                    0,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    0,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    60,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    4,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    69,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    72
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"9#11",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    61,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    73,
                    81
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"13",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    77,
                    69,
                    71,
                    76
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"13b9",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    64,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    77,
                    68,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    76,
                    80
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"13b5b9",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    64,
                    65,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    65,
                    68,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    68,
                    73,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    68,
                    73,
                    77
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"b13b9",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    65,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    71,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    71,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"b13#9",
           "positions":[
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    71,
                    63,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    65,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    65,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    71,
                    77
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"maj7",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    67,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    71,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"maj7b5",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    79,
                    71,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"maj7#5",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    0,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    67,
                    63,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    75,
                    67,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    71,
                    75,
                    78
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"maj9",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":10,
                 "midi":[
                    78,
                    71,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"maj11",
           "positions":[
              {
                 "frets":[
                    2,
                    0,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    0,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    60,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    69,
                    72
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"maj13",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    64,
                    66,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    66,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    71,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    71,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"m6",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    2,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    64,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"m7",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    0,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":1,
                 "midi":[
                    67,
                    62,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    74,
                    67,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    70,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"m7b5",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    2,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"m9",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    1,
                    0
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    70,
                    77
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"m69",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    0,
                    0
                 ],
                 "fingers":[
                    3,
                    2,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    70,
                    76
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"m9b5",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    1,
                    0
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    61,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    61,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":6,
                 "midi":[
                    73,
                    69,
                    70,
                    77
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"m11",
           "positions":[
              {
                 "frets":[
                    2,
                    0,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    0,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":1,
                 "midi":[
                    69,
                    60,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    0,
                    1,
                    0
                 ],
                 "fingers":[
                    3,
                    0,
                    1,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    60,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    69,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    0
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    0
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    65,
                    70,
                    69
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"mmaj7",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    0,
                    2,
                    3,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    66,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":6,
                 "midi":[
                    74,
                    67,
                    70,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":9,
                 "midi":[
                    79,
                    70,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"mmaj7b5",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    3,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    66,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    67,
                    70,
                    78
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"mmaj9",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    2,
                    0
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    66,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    66,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    70,
                    78
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"mmaj11",
           "positions":[
              {
                 "frets":[
                    2,
                    0,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    0,
                    3,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    60,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    0,
                    2,
                    0
                 ],
                 "fingers":[
                    3,
                    0,
                    2,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    60,
                    66,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    66,
                    69,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    0
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    0
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    69
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"add9",
           "positions":[
              {
                 "frets":[
                    2,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    67,
                    71
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":4,
                 "midi":[
                    71,
                    67,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":7,
                 "midi":[
                    74,
                    69,
                    71,
                    79
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":10,
                 "barres":[

                 ],
                 "midi":[
                    79,
                    71,
                    74,
                    81
                 ]
              }
           ]
        },
        {
           "key":"G",
           "suffix":"madd9",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    3,
                    0
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    67,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    69,
                    62,
                    67,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    79,
                    70,
                    74,
                    81
                 ]
              }
           ]
        }
     ],
     "Gb":[
        {
           "key":"Gb",
           "suffix":"major",
           "positions":[
              {
                 "frets":[
                    3,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    61,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    61,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    70,
                    78
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    78,
                    70,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"minor",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    2,
                    0
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    61,
                    66,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    61,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    2,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    78,
                    69,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"dim",
           "positions":[
              {
                 "frets":[
                    2,
                    0,
                    2,
                    0
                 ],
                 "fingers":[
                    2,
                    0,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    60,
                    66,
                    69
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    69,
                    72
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    78,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"dim7",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"sus2",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    73,
                    66,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "barres":[
                    4
                 ],
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    78,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"sus4",
           "positions":[
              {
                 "frets":[
                    4,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    61,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":4,
                 "midi":[
                    71,
                    66,
                    71,
                    73
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":4,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    71,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    71,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"7sus4",
           "positions":[
              {
                 "frets":[
                    4,
                    4,
                    2,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    71,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    71,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    73,
                    76,
                    83
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"alt",
           "positions":[
              {
                 "frets":[
                    3,
                    0,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    0,
                    2,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    60,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    66,
                    70,
                    72
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    2
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    70,
                    72,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"aug",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":1,
                 "midi":[
                    70,
                    62,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    70,
                    62,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    66,
                    70,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    74,
                    66,
                    70,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"6",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    63,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    73,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"69",
           "positions":[
              {
                 "frets":[
                    3,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    3,
                    4
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    63,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    70,
                    73,
                    80
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    73,
                    75,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"7",
           "positions":[
              {
                 "frets":[
                    3,
                    4,
                    2,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    70,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    73,
                    76,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"7b5",
           "positions":[
              {
                 "frets":[
                    3,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    76,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"aug7",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    74,
                    66,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    70,
                    74,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    74,
                    76,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"9",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    3
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    70,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"9b5",
           "positions":[
              {
                 "frets":[
                    1,
                    0,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    0,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    60,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    3,
                    4
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    72,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"aug9",
           "positions":[
              {
                 "frets":[
                    1,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    70,
                    64,
                    68,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    74,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"7b9",
           "positions":[
              {
                 "frets":[
                    0,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    3,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    67,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    73,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"7b9#5",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    2,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    64,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"7#9",
           "positions":[
              {
                 "frets":[
                    2,
                    1,
                    0,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    61,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    0,
                    0
                 ],
                 "fingers":[
                    3,
                    1,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    61,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    69,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    69,
                    70,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"11",
           "positions":[
              {
                 "frets":[
                    3,
                    4,
                    4,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    4,
                    4,
                    4,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    71,
                    64,
                    68,
                    70
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"9#11",
           "positions":[
              {
                 "frets":[
                    1,
                    0,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    0,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    60,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    3,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    3,
                    4
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    70,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    72,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"13",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    0,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    63,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    76,
                    68,
                    70,
                    75
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"13b9",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    3,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    64,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    76,
                    67,
                    70,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    4,
                    3
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    75,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"13b5b9",
           "positions":[
              {
                 "frets":[
                    0,
                    3,
                    0,
                    3
                 ],
                 "fingers":[
                    0,
                    1,
                    0,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    63,
                    64,
                    72
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    64,
                    67,
                    75
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    67,
                    72,
                    75
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":7,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    67,
                    72,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"b13b9",
           "positions":[
              {
                 "frets":[
                    0,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    0,
                    2,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    67,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":3,
                 "midi":[
                    70,
                    64,
                    67,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    67,
                    70,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    70,
                    74,
                    79
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"b13#9",
           "positions":[
              {
                 "frets":[
                    3,
                    2,
                    0,
                    0
                 ],
                 "fingers":[
                    3,
                    2,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    62,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    0,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    0,
                    1
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    62,
                    64,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    64,
                    69,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    74,
                    69,
                    70,
                    76
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"maj7",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    66,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    2,
                    1
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    70,
                    73,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    77,
                    70,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"maj7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    72,
                    66,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    78,
                    70,
                    72,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    72,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"maj7#5",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    66,
                    74
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    74,
                    66,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    3,
                    1
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    70,
                    74,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    2,
                    3,
                    4,
                    1
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    70,
                    74,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"maj9",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    70,
                    65,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":9,
                 "midi":[
                    77,
                    70,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"maj11",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    2,
                    4,
                    3,
                    1
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    3,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    71,
                    77,
                    82
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"maj13",
           "positions":[
              {
                 "frets":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    63,
                    65,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":3,
                 "barres":[

                 ],
                 "midi":[
                    70,
                    65,
                    68,
                    75
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":6,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    68,
                    70,
                    77
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    1,
                    2
                 ],
                 "capo":true,
                 "baseFret":10,
                 "midi":[
                    77,
                    70,
                    75,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"m6",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    63,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    66,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"m7",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    73,
                    66,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    69,
                    73,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":11,
                 "midi":[
                    78,
                    73,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"m7b5",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    2,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    64,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    76,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    72,
                    76,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"m9",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    0,
                    0
                 ],
                 "fingers":[
                    1,
                    2,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    76,
                    69,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"m69",
           "positions":[
              {
                 "frets":[
                    2,
                    3,
                    4,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    63,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    2,
                    4,
                    1,
                    3
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    69,
                    75
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    2,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    4
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    75,
                    69,
                    73,
                    80
                 ]
              },
              {
                 "frets":[
                    3,
                    3,
                    1,
                    2
                 ],
                 "fingers":[
                    3,
                    4,
                    1,
                    2
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    73,
                    75,
                    81
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"m9b5",
           "positions":[
              {
                 "frets":[
                    1,
                    0,
                    0,
                    0
                 ],
                 "fingers":[
                    1,
                    0,
                    0,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    60,
                    64,
                    69
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    4,
                    3
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    2
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    64,
                    68,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    68,
                    69,
                    76
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    76,
                    69,
                    72,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"m11",
           "positions":[
              {
                 "frets":[
                    2,
                    4,
                    4,
                    2
                 ],
                 "fingers":[
                    1,
                    3,
                    4,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    69,
                    64,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":11,
                 "midi":[
                    80,
                    71,
                    76,
                    81
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":11,
                 "midi":[
                    81,
                    71,
                    76,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"mmaj7",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    65,
                    66,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":5,
                 "midi":[
                    73,
                    66,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    2,
                    1
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":8,
                 "midi":[
                    78,
                    69,
                    73,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    77,
                    69,
                    73,
                    78
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"mmaj7b5",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    1,
                    2
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    65,
                    66,
                    72
                 ]
              },
              {
                 "frets":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    2,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":5,
                 "midi":[
                    72,
                    66,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    2
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    3
                 ],
                 "baseFret":8,
                 "barres":[

                 ],
                 "midi":[
                    77,
                    69,
                    72,
                    78
                 ]
              },
              {
                 "frets":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "fingers":[
                    4,
                    2,
                    1,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":8,
                 "midi":[
                    78,
                    69,
                    72,
                    77
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"mmaj9",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    1,
                    0
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    65,
                    69
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    3,
                    3
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    3
                 ],
                 "baseFret":2,
                 "barres":[

                 ],
                 "midi":[
                    69,
                    65,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    2,
                    4,
                    1,
                    4
                 ],
                 "fingers":[
                    2,
                    3,
                    1,
                    4
                 ],
                 "baseFret":5,
                 "barres":[

                 ],
                 "midi":[
                    73,
                    68,
                    69,
                    77
                 ]
              },
              {
                 "frets":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    2,
                    1,
                    1,
                    3
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":9,
                 "midi":[
                    77,
                    69,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"mmaj11",
           "positions":[
              {
                 "frets":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "fingers":[
                    1,
                    4,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":2,
                 "midi":[
                    69,
                    65,
                    68,
                    71
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    3,
                    2
                 ],
                 "fingers":[
                    3,
                    1,
                    4,
                    2
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    80,
                    71,
                    77,
                    81
                 ]
              },
              {
                 "frets":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "fingers":[
                    4,
                    1,
                    3,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":11,
                 "midi":[
                    81,
                    71,
                    77,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"add9",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "fingers":[
                    1,
                    1,
                    2,
                    1
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":1,
                 "midi":[
                    68,
                    61,
                    66,
                    70
                 ]
              },
              {
                 "frets":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "fingers":[
                    1,
                    4,
                    2,
                    2
                 ],
                 "barres":[
                    2
                 ],
                 "baseFret":3,
                 "midi":[
                    70,
                    66,
                    68,
                    73
                 ]
              },
              {
                 "frets":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "fingers":[
                    1,
                    3,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "capo":true,
                 "baseFret":6,
                 "midi":[
                    73,
                    68,
                    70,
                    78
                 ]
              },
              {
                 "frets":[
                    3,
                    2,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    2,
                    1,
                    4
                 ],
                 "baseFret":9,
                 "barres":[

                 ],
                 "midi":[
                    78,
                    70,
                    73,
                    80
                 ]
              }
           ]
        },
        {
           "key":"Gb",
           "suffix":"madd9",
           "positions":[
              {
                 "frets":[
                    1,
                    1,
                    2,
                    0
                 ],
                 "fingers":[
                    1,
                    2,
                    3,
                    0
                 ],
                 "baseFret":1,
                 "barres":[

                 ],
                 "midi":[
                    68,
                    61,
                    66,
                    69
                 ]
              },
              {
                 "frets":[
                    3,
                    1,
                    1,
                    3
                 ],
                 "fingers":[
                    3,
                    1,
                    1,
                    4
                 ],
                 "barres":[
                    1
                 ],
                 "baseFret":9,
                 "midi":[
                    78,
                    69,
                    73,
                    80
                 ]
              },
              {
                 "frets":[
                    4,
                    3,
                    4,
                    1
                 ],
                 "fingers":[
                    3,
                    2,
                    4,
                    1
                 ],
                 "baseFret":11,
                 "barres":[

                 ],
                 "midi":[
                    81,
                    73,
                    78,
                    80
                 ]
              }
           ]
        }
     ]
  }
}`)

export { ukuleleChords }